import { render, staticRenderFns } from "./RolesCard.vue?vue&type=template&id=34679b63&scoped=true"
import script from "./RolesCard.vue?vue&type=script&lang=js"
export * from "./RolesCard.vue?vue&type=script&lang=js"
import style0 from "./RolesCard.vue?vue&type=style&index=0&id=34679b63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34679b63",
  null
  
)

export default component.exports